export enum ActionReport {
  'Pick up' = 'pick-up',
  'Stock up' = 'stock-up',
  'Manual edit' = 'manual-edit',
  'Auto edit' = 'auto-edit',
}
